import JsBarcode from 'jsbarcode';

export type BarcodeSymbology = 'CODE128' | 'CODE39';

/** Alto máximo del código de barras dentro de la franja de etiqueta (mm). */
export const LABEL_BARCODE_SVG_MAX_HEIGHT_MM = 6.2;

/** JsBarcode para ventana de impresión (un poco más grande que el default). */
export const LABEL_BARCODE_PRINT_JS_OPTIONS = {
  width: 0.98,
  height: 38,
} as const;

/** JsBarcode para miniatura en pantalla (proporcional a impresión). */
export const LABEL_BARCODE_PREVIEW_JS_OPTIONS = {
  width: 0.62,
  height: 34,
} as const;

/**
 * Renders CODE128 (default) onto an SVG element. Value must match productCodeUnique for scanners.
 */
export function renderBarcodeSvg(
  svgEl: SVGSVGElement | null,
  value: string,
  options?: { format?: BarcodeSymbology; width?: number; height?: number },
): void {
  if (!svgEl || !value?.trim()) return;
  while (svgEl.firstChild) {
    svgEl.removeChild(svgEl.firstChild);
  }
  try {
    JsBarcode(svgEl, value, {
      format: options?.format ?? 'CODE128',
      width: options?.width ?? 0.85,
      height: options?.height ?? 28,
      displayValue: false,
      margin: 0,
      background: '#ffffff',
      lineColor: '#000000',
    });
  } catch {
    /* invalid data for symbology — leave svg empty */
  }
}

/** Inline SVG string for print HTML (no script needed in print window). */
export function barcodeToSvgString(
  value: string,
  options?: { format?: BarcodeSymbology; width?: number; height?: number },
): string {
  if (!value?.trim()) return '';
  const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  try {
    JsBarcode(svg, value, {
      format: options?.format ?? 'CODE128',
      width: options?.width ?? 0.75,
      height: options?.height ?? 26,
      displayValue: false,
      margin: 0,
      background: '#ffffff',
      lineColor: '#000000',
    });
  } catch {
    return '';
  }
  return svg.outerHTML;
}
